import { writable } from "svelte/store";
export class BusyWorkManager {
    constructor() {
        this.isBusyStore = writable(false);
        this.inProgress = [];
    }
    /**
     * Gets the busy store.
     */
    getIsBusyStore() {
        return this.isBusyStore;
    }
    isBusy(worker, busyWork) {
        const i = this.inProgress.findIndex(x => x.work == busyWork && x.worker == worker);
        if (i === -1) {
            this.inProgress.push({ work: busyWork, worker: worker });
            this.isBusyStore.set(this.inProgress.length > 0);
            //console.log(`isBusy reported, isBusyStore=${get(this.isBusyStore)}, ${this.inProgress.map(x => `${x.worker}@${x.work}`)}`);
        }
    }
    isDone(worker, busyWork) {
        const i = this.inProgress.findIndex(x => x.work == busyWork && x.worker == worker);
        if (i === -1)
            return;
        this.inProgress.splice(i, 1);
        this.isBusyStore.set(this.inProgress.length > 0);
        //console.log(`isDone reported, isBusyStore=${get(this.isBusyStore)}, ${this.inProgress.map(x => `${x.worker}@${x.work}`)}`);
    }
}
